import { h } from 'preact';

const FormField = ({ config, value, onInput, error, autoComplete }) => {
  const { type, label, mapping, options } = config;
  
  const handleChange = (e) => onInput(e.target.value);

  return (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      {/* 1. htmlFor must match the input ID exactly */}
      <label htmlFor={mapping}>{label}</label>
      
      {type === 'text' && (
        <input 
          id={mapping} 
          name={mapping} // Added name for browser autofill
          type="text" 
          className={error ? 'has-error' : ''}
          value={value || ''} 
          onInput={handleChange} 
          autoComplete={autoComplete || "on"}
        />
      )}

      {(type === 'multiple-choice' || type === 'select') && (
        <select 
          id={mapping} 
          name={mapping}
          className={error ? 'has-error' : ''} 
          value={value || ''} 
          onChange={handleChange}
        >
          <option value="">-- Select One --</option>
          {options?.map((opt, i) => (
            <option key={i} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}

      {type === 'checkbox-list' && (
        <div className="checkbox-group" role="group" aria-labelledby={mapping}>
          {options?.map((opt, i) => {
            const checkId = `${mapping}-${i}`; // Unique ID for every checkbox
            return (
              <div key={i} className="checkbox-item">
                <input 
                  type="checkbox" 
                  id={checkId} 
                  name={mapping}
                  checked={(value || []).includes(opt.value)}
                  onChange={(e) => {
                    let current = Array.isArray(value) ? [...value] : [];
                    if (e.target.checked) current.push(opt.value);
                    else current = current.filter(v => v !== opt.value);
                    onInput(current);
                  }}
                />
                <label htmlFor={checkId}>{opt.label}</label>
              </div>
            );
          })}
        </div>
      )}

      {type === 'date-picker' && (
        <input 
          id={mapping} 
          name={mapping}
          type="date" 
          className={error ? 'has-error' : ''} 
          value={value || ''} 
          onChange={handleChange} 
        />
      )}

      {type === 'text-area' && (
        <textarea 
          id={mapping} 
          name={mapping}
          className={error ? 'has-error' : ''}
          rows="4" 
          value={value || ''} 
          onInput={handleChange} 
        />
      )}

      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default FormField;